import { render, staticRenderFns } from "./ListInventoryTemplateDetailComponent.vue?vue&type=template&id=18ded089&scoped=true&"
import script from "./ListInventoryTemplateDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ListInventoryTemplateDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ded089",
  null
  
)

export default component.exports